<template>
  <span :style="{fontSize: fontSize}"
        :class="{accrual: type === 'accrual', debit: type === 'debit', neutral: type === 'neutral'}"
        class="money-message">
    <strong>{{ moneyAmount | formatMoney }}</strong>&nbsp;
    <span v-if="type !== 'neutral'" class="currency">{{currency}}</span>
  </span>
</template>

<script>
export default {
  name: 'MoneyMessage',
  props: {
    moneyAmount: {
      default: 0,
    },
    currency: {
      type: String,
    },
    type: {
      type: String,
      validator(val) {
        return ['accrual', 'debit', 'neutral'].includes(val);
      },
      default: 'accrual',
    },
    fontSize: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .accrual {
    color: var(--accent-green);
  }
  .debit {
    color: var(--error-red);
  }
  .neutral {
    color: var(--text-main-color);
    opacity: 0.6;
  }
  .currency {
    font-size: 0.8em;
  }
</style>
